import api from "./api";

export const dashboardService = {
  async getDashboard(params = {}) {
    try {
      const response = await api.get("/dashboard", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getStats(params = {}) {
    try {
      const response = await api.get("/dashboard/stats", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getActivity(params = {}) {
    try {
      const response = await api.get("/dashboard/activity", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCharts(params = {}) {
    try {
      const response = await api.get("/dashboard/charts", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default dashboardService;
